import React, { ReactNode } from "react";

import { IgPaper } from "@intelligems/ig-theme";
import { Grid } from "@mui/material";

import { KimcheeStandingPose } from "../../../../images/KimcheeStandingPose";

interface AiSectionProps {
  hideAbie?: boolean;
  leftNode: ReactNode;
  rightNode?: ReactNode;
}

export const Template = ({ leftNode, rightNode, hideAbie }: AiSectionProps) => {
  return (
    <Grid item>
      <IgPaper
        sx={{
          padding: "15px 30px 15px 30px",
          backgroundColor: "#F7E9DC",
        }}
      >
        <Grid
          container
          columnSpacing={2}
          justifyContent={"space-between"}
          flexWrap={"nowrap"}
        >
          <Grid item>
            <Grid container item columnSpacing={2} flexWrap={"nowrap"}>
              {hideAbie ? null : (
                <Grid item>
                  <KimcheeStandingPose
                    sx={{
                      width: "60px",
                      height: "60px",
                      marginTop: "-2px",
                      marginBottom: "-5px",
                    }}
                  />
                </Grid>
              )}
              <Grid item>{leftNode}</Grid>
            </Grid>
          </Grid>
          <Grid item>{rightNode ? rightNode : null}</Grid>
        </Grid>
      </IgPaper>
    </Grid>
  );
};
